module.exports = __webpack_public_path__ + "img/img5.1227085f.jpg";